module.exports = __webpack_public_path__ + "img/pending.16175094.svg";